/**
 * PERSONAS Y AGENTES, SEPARADOS EN LA LISTA DE USUARIOS (SUJ-T2 b, ASSIGN #17005).
 *
 * QUE PASO. Josse abrio Usuarios y vio 5 filas con "?" mezcladas con las personas: eran los
 * agentes con rol 'agent' (sin nombre ni correo). Y detras hay 7 mas que no se notan: Ares,
 * Argemiro y los Argys viejos tienen rol 'user' y un nombre "(Agente)". Medido el 21-sep en
 * nexo_private.users: 16 filas = 4 personas (admin, manager, dev, viewer) + 12 agentes.
 *
 * El contrato de persona (spec-persona-v1) dice que un agente NO es persona. Aqui se aplica
 * la misma frontera para PINTAR: un usuario es agente si su rol es 'agent', si su nombre dice
 * "(Agente)" o si su id tiene forma de codigo de agente (ARES-, ARGEMIRO-, ARGY-, ARGYS-).
 * Ningun agente se borra ni se esconde del todo: va aparte y dicho como agente.
 *
 * Sin DOM: lo prueba scripts/check-usuarios-personas.mjs.
 */

const CODIGO_DE_AGENTE = /^(ARES|ARGEMIRO|ARGYS?)-/i;

/** true si el usuario es un agente y no una persona. */
export function esAgente(u) {
  if (!u) return false;
  const rol = String(u.role ?? u.rol ?? '').trim().toLowerCase();
  if (rol === 'agent') return true;
  const nombre = String(u.displayName ?? u.display_name ?? u.nombre ?? '');
  if (/\(Agente?\)/i.test(nombre)) return true;
  return CODIGO_DE_AGENTE.test(String(u.id ?? u.uid ?? '').trim());
}

/**
 * SUJ-T8 (nexo-api 306): la API dice por fila que es cada usuario -- sujeto = persona |
 * login_compartido | agente | sin_persona, de persona_llaves y del rol. La frontera sale del
 * endpoint, no de una lista del panel (#17058): Maderinco (login compartido del negocio) y
 * Developer/Viewer (sin persona) dejan de contarse como personas. Sin el campo (API vieja) se usa
 * la regla de siempre.
 */
export function sujetoDe(u) {
  const s = String(u?.sujeto ?? '').trim().toLowerCase();
  if (['persona', 'login_compartido', 'agente', 'sin_persona'].includes(s)) return s;
  return esAgente(u) ? 'agente' : 'persona';
}

/** { personas, agentes, cuentas }, en el orden en que llegaron. cuentas = login compartido o sin persona. */
export function separarPersonasDeAgentes(usuarios) {
  const personas = [];
  const agentes = [];
  const cuentas = [];
  for (const u of Array.isArray(usuarios) ? usuarios : []) {
    const s = sujetoDe(u);
    (s === 'persona' ? personas : s === 'agente' ? agentes : cuentas).push(u);
  }
  return { personas, agentes, cuentas };
}

/** Por que una cuenta no es persona, en idioma de dueno. */
export function porQueNoEsPersona(u) {
  return sujetoDe(u) === 'login_compartido'
    ? 'login del negocio: lo comparten varias personas'
    : 'cuenta del sistema, sin persona detrás';
}

/** El nombre que se pinta: nunca vacio ni "?" (un agente sin nombre se llama por su codigo). */
export function nombreVisible(u) {
  if (!u) return '';
  const n = String(u.displayName ?? u.display_name ?? '').trim();
  if (n) return n;
  const e = String(u.email ?? '').trim();
  if (e) return e;
  return String(u.id ?? u.uid ?? '').trim() || 'sin nombre';
}
